
<div class="border-0 px-4 py-1 overflow-auto">
    <NavigationBackButton/>
     <div class="card-header card-header-primary text-white shadow rounded-lg mt-3">
        <div class="nav-tabs-navigation">
            <div class="nav-tabs-wrapper">
            <ul class="nav nav-tabs" data-tabs="tabs">
                <li class="rounded-lg me-2 nav-item">
                <a class="text-white text-decoration-none fs-5 fw-bold nav-link" href="#profile" data-toggle="tab">
                    <span><i class="bi bi-hdd-stack fs-4 me-2"></i></span>Manage Your Services
                </a>
                </li>
            </ul>
            <div class="d-block ms-3 text-end">
                <button class="btn btn-primary-dark btn-sm  text-xxs shadow mb-1"
                 data-bs-toggle="modal"
                 data-bs-target="#create_service"
                 @click="open_create_modal">
                Create New Service
                </button>

                </div>
            </div>
        </div>
    </div>
    <div class="glassy-table mt-2 rounded-lg border-0 shadow">
        <div class="card-body rounded-lg shadow">
            
            <div class="p-4 border-0 rounded-lg">
                <div class="table-responsive">
                    <table id="forms_table" class="table table-hover">
                        <thead class="custom-header">
                            <tr>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Name
                                </th>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">
                                    Description</th>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Last
                                    Modified</th>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Price
                                </th>
                                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Changed from 'forms' to 'table_safe_form_list' -->
                            <tr v-for="(service) in table_safe_form_list" :key="service.id">
                                <td class="text-xxs text-start">{{ service.name }}</td>
                                <td class="text-xxs text-start">{{ service.description }}</td>
                                <td class="text-xxs text-start">{{ this.format_date(service.last_modified) }}</td>
                                <td class="text-xxs text-start">
                                    <span class="status-badge">{{ service.price }}</span>
                                </td>

                                <td>
                                    <button class="btn btn-primary-dark btn-sm rounded shadow me-2 text-xxs"
                                        data-bs-toggle="modal" data-bs-target="#edit_service"
                                        @click="open_edit_modal(service)">Edit</button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<teleport to="body">
<div class="modal fade" id="edit_service" tabindex="-1" aria-labelledby="edit_service_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h5 class="modal-title text-white text-xxs">Edit Service</h5>
        <button type="button" class="modal-btn-close btn-close"data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
        <div class="mb-3">
            <label class="modal-form-label form-label text-xxs">Service Name:</label>
            <input type="text" class="modal-form-control form-control text-xxs" v-model="current_service.service_name" placeholder="Enter service name">
        </div>
        <div class="mb-3">
            <label class="modal-form-label form-label text-xxs">Service Description:</label>
            <textarea class="modal-form-control form-control text-xxs" v-model="current_service.service_description" ></textarea>
        </div>
        <!-- Service VAT Inclusion -->
        <div class="mb-3">
            <label class="modal-form-label form-label text-xxs">Is this service VAT inclusive or exclusive?</label>
            <div class="d-flex gap-3">
                <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    id="vat_inclusive"
                    value="true"
                    v-model="current_service.vat_inclusive"
                >
                <label class="form-check-label text-xxs" for="vat_inclusive">
                    Inclusive of VAT
                </label>
                </div>
                <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    id="vat_exclusive"
                    value="false"
                    v-model="current_service.vat_inclusive"
                >
                <label class="form-check-label text-xxs" for="vat_exclusive">
                    Exclusive of VAT
                </label>
                </div>
            </div>
        </div>

                    <!-- VAT Exempt -->
                    <div class="mb-3">
                        <label class="modal-form-label form-label text-xxs">Is this service exempt from VAT?</label>
                        <div class="d-flex gap-3">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="vat_exempt_yes" value="true"
                                    v-model="current_service.vat_exempt">
                                <label class="form-check-label text-xxs" for="vat_exempt_yes">
                                    Yes
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="vat_exempt_no" value="false"
                                    v-model="current_service.vat_exempt">
                                <label class="form-check-label text-xxs" for="vat_exempt_no">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="modal-form-label form-label text-xxs">Service Price:</label>
                        <input type="text" class="modal-form-control form-control text-xxs"
                            v-model="current_service.price" placeholder="Enter price">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                        @click="update_service">
                        Save
                    </button>

                </div>
            </div>
        </div>
    </div>
</teleport>

<teleport to="body">
<div class="modal fade" id="create_service" tabindex="-1" aria-labelledby="create_service_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <h5 class="modal-title text-white text-xxs">Create Service </h5>
            <button type="button" class="modal-btn-close btn-close"  data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="mb-3">
                <label class="modal-form-label form-label text-xxs">Service Name:</label>
                <input type="text" class="modal-form-control form-control text-xxs" v-model="current_service.service_name" placeholder="Enter service name">
            </div>
            <div class="mb-3">
                <label class="modal-form-label form-label text-xxs">Service Description:</label>
                <textarea class="modal-form-control form-control text-xxs" v-model="current_service.service_description"></textarea>
            </div>
            <!-- Service VAT Inclusion -->
            <div class="mb-3">
                <label class="modal-form-label form-label text-xxs">Is this service VAT inclusive or exclusive?</label>
                <div class="d-flex gap-3">
                    <div class="form-check">
                    <input
                        class="form-check-input"
                        type="radio"
                        id="vat_inclusive"
                        value="true"
                        v-model="current_service.vat_inclusive"
                    >
                    <label class="form-check-label text-xxs" for="vat_inclusive">
                        Inclusive of VAT
                    </label>
                    </div>
                    <div class="form-check">
                    <input
                        class="form-check-input"
                        type="radio"
                        id="vat_exclusive"
                        value="false"
                        v-model="current_service.vat_inclusive"
                    >
                    <label class="form-check-label text-xxs" for="vat_exclusive">
                        Exclusive of VAT
                    </label>
                    </div>
                </div>
            </div>

                    <!-- VAT Exempt -->
                    <div class="mb-3">
                        <label class="modal-form-label form-label text-xxs">Is this service exempt from VAT?</label>
                        <div class="d-flex gap-3">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="vat_exempt_yes" value="true"
                                    v-model="current_service.vat_exempt">
                                <label class="form-check-label text-xxs" for="vat_exempt_yes">
                                    Yes
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" id="vat_exempt_no" value="false"
                                    v-model="current_service.vat_exempt">
                                <label class="form-check-label text-xxs" for="vat_exempt_no">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="modal-form-label form-label text-xxs">Service Price:</label>
                        <input type="text" class="modal-form-control form-control text-xxs"
                            v-model="current_service.price" placeholder="Enter service price">
                    </div>


                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                        @click="create_service">Save</button>
                </div>
            </div>
        </div>
    </div>
</teleport>